import { Text } from '@digibee/beehive-ui';
import { ArrowLeftCircle } from 'iconoir-react';
import { FC, MouseEvent, ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 32px;
  background: ${props => props.theme.colors.white};
  border-bottom: 1px solid ${props => props.theme.colors.gra300};
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

const ContentBack = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
`;

const IconWrapper = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
`;

const ContentTitle = styled.div`
  display: flex;
  justify-content: center;
  gap: 2px;
  align-items: center;
  width: 100%;
`;

interface Props {
  title: string;
  linkText: string;
  onBack: (isTargetBlank: boolean) => void;
  afterTitle?: ReactNode;
}

const TopBar: FC<Props> = ({ title, linkText, onBack, afterTitle }) => {
  const onClick = (event: MouseEvent<HTMLDivElement>) => {
    const isTargetBlank = event.metaKey || event.ctrlKey;
    onBack(isTargetBlank);
  };

  return (
    <Container>
      <ContentBack
        data-testid='build-topbar-back-to-pipelines-link'
        onClick={onClick}
      >
        <IconWrapper>
          <ArrowLeftCircle
            className='icon-smallest text-secondary'
            data-testid='build-topbar-back-to-pipelines-link'
          />
        </IconWrapper>
        <Text variant='b2' css={{ color: '$pri500', fontWeight: '$medium' }}>
          {linkText}
        </Text>
      </ContentBack>
      <ContentTitle>
        <Text variant='b2' css={{ fontWeight: 500 }}>
          {title}
        </Text>
        {afterTitle && afterTitle}
      </ContentTitle>
    </Container>
  );
};

export default TopBar;
